<form
	(ngSubmit)="submit(form)"
	[formGroup]="form">

	<div class="ngx-dialog goreact-modal change-email-dialog-container">
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="modal-change-email_change-email"></h4>
			<button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close'| translate">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body" #content>
			<mat-form-field appearance="outline" class="new-email">
				<mat-label translate="modal-change-email_new-email"></mat-label>
				<input type="email" matInput formControlName="newEmail" class="fullstory-ignore" />
				<mat-error *ngIf="form.controls.newEmail.hasError('required')" translate="common-validation_email-required"></mat-error>
				<mat-error *ngIf="form.controls.newEmail.hasError('email')" translate="common-validation_email"></mat-error>
			</mat-form-field>

			<mat-form-field appearance="outline" class="password" goPasswordVisibilityToggle>
				<mat-label translate="modal-change-email_current-password"></mat-label>
				<input type="password" matInput formControlName="password" class="fullstory-ignore password-input" />
				<mat-error *ngIf="form.controls.password.hasError('required')" translate="modal-change-email_error-password"></mat-error>
				<mat-error *ngIf="form.controls.password.hasError('incorrect')" translate="common-validation_incorrect-password"></mat-error>
			</mat-form-field>
		</div>
		<div class="goreact-modal-footer">
			<span class="error-text" *ngIf="error">{{ error }}</span>
			<button
				type="button"
				class="cancel-btn tertiary-btn"
				(click)="close()"
				[attr.aria-label]="'common_cancel'| translate">
				{{'common_cancel' | translate}}
			</button>
			<button
				type="submit"
				class="primary-btn submit-btn"
				[attr.aria-label]="'modal-change-email_change-email' | translate"
				[disabled]="(loading$ | async)"
				[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">
				<i class="ficon-spinner ficon-spin" *ngIf="loading$ | async"></i>
				<span translate="modal-change-email_change-email"></span>
			</button>
		</div>
	</div>
</form>
